import { Stack, Typography } from "@mui/material";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import Button from "../../Button";
import { useNavigate } from "react-router-dom";

export const BillingSuccessful = () => {
  const navigate = useNavigate();
  return (
    <Stack
      height={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
      gap={2}
    >
      <Stack backgroundColor="#E7F1F9" borderRadius={"16px"} p={2}>
        <CreditScoreIcon sx={{ color: "#0A72C3", width: 32, height: 32 }} />
      </Stack>
      <Typography color="#1F292E" fontWeight={700} fontSize={"1.35rem"}>
        Payment successful
      </Typography>
      <Typography color="#415058" fontSize={"1rem"}>
        Log back in to enjoy your new subscription
      </Typography>
      <Button
        style={{ paddingInline: "1rem", fontWeight: 600 }}
        onClick={() => navigate("/Login")}
      >
        Log back into my account
      </Button>
    </Stack>
  );
};
